import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import WhySection from "../../../../components/WhySection/WhySection";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function FundsAssetManagementLicensePanama() {

    return (
        <main className='main'>
            <SEO
                title=""
                description=""
                keywords=""
                url="/funds-asset-management-license-panama"
            />
            <IntroSection
                title="Funds & Asset Management License – Panama"
                subtitle="Launch Your Fund, Brokerage, or Asset Management Firm in Latin America"
                description="Panama is a growing hub for funds, broker-dealers, and investment advisors, supervised by the Superintendence of Securities Market (SMV). With its territorial tax system (no tax on foreign-sourced income), strong financial sector, and global recognition, Panama is attractive for private equity, hedge funds, family offices, and investment managers targeting the LatAm and international markets."
                badges={[
                    "Investment Funds",
                    "Broker-Dealer License",
                    "Investment Advisor License",
                    "Family Offices"
                ]}
                buttonText="Request a Panama Funds Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/funds-asset-management-license-panama-hero.png")}
                imageAlt="Panama Funds & Asset Management"
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Panama for Funds & Asset Management?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Regional Recognition",
                                                text: "Strong investor confidence in Latin America."
                                            },
                                            {
                                                title: "SMV-Regulated",
                                                text: "Clear legal framework under Panama’s securities law."
                                            },
                                            {
                                                title: "Flexible Structures",
                                                text: "Private funds, public funds, broker-dealers, and investment advisors."
                                            },
                                            {
                                                title: "Tax Benefits",
                                                text: "Foreign investment income is exempt from local tax."
                                            },
                                            {
                                                title: "Global Access",
                                                text: "Panama bridges North America, South America, and Europe."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Licenses in Panama"
                        blocks={[
                            {
                                title: "Investment Fund License",
                                items: [
                                    { text: "Public Funds — marketed to retail investors." },
                                    { text: "Private Funds — limited to qualified/professional investors." },
                                    { text: "Popular for hedge funds, PE/VC, and real estate funds." },
                                    { text: "Capital Requirement: ~USD 150,000 minimum (varies)." }
                                ]
                            },
                            {
                                title: "Broker-Dealer License",
                                items: [
                                    { text: "Authorized to trade securities on behalf of clients or own account." },
                                    { text: "Includes market-making, custody, and clearing services." },
                                    { text: "Capital Requirement: USD 250,000+." }
                                ]
                            },
                            {
                                title: "Investment Advisor License",
                                items: [
                                    { text: "Provide portfolio management, investment advice, and asset allocation." },
                                    { text: "Suitable for family offices and independent managers." },
                                    { text: "Capital Requirement: USD 150,000 minimum." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of a Panama Fund or Asset Management License'
                        services={
                            [
                                {
                                    title: "International Recognition",
                                    text: "Trusted regional regulator (SMV)."
                                },
                                {
                                    title: "Investor Flexibility",
                                    text: "Private and professional investor funds available."
                                },
                                {
                                    title: "Tax Neutrality",
                                    text: "Offshore investment income is not taxed locally."
                                },
                                {
                                    title: "Scalable",
                                    text: "Start with an advisor license, expand into full fund or broker-dealer."
                                },
                                {
                                    title: "Cost Advantage",
                                    text: "Lower setup costs versus Luxembourg, Ireland, or Malta."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Choose fund, advisor, or broker-dealer license."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish a Panama entity."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Prepare business plan, AML/KYC manuals, and financial proof."
                                },
                                {
                                    title: "SMV Review",
                                    text: "Due diligence on shareholders, directors, and compliance staff."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically completed in 6–9 months."
                                }
                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Specialists in Panama fund, brokerage, and asset management licensing."
                                },
                                {
                                    text: "End-to-end support: incorporation, license application, compliance."
                                },
                                {
                                    text: "Introductions to custodians, fund administrators, and brokers."
                                },
                                {
                                    text: "Balanced comparison: Panama vs Malta vs Cyprus vs Offshore funds."
                                },
                                {
                                    text: "Long-term compliance & audit support."
                                }
                            ]
                        }
                    />
                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a fund, brokerage, or asset management firm in Latin America?"
                        description="Panama offers investment fund, broker-dealer, and advisor licenses with strong regional recognition and tax advantages."
                        buttonText="Book a Panama Funds License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What’s the difference between public and private funds in Panama?",
        content: [
            { type: "answer", text: "Public = retail investors, heavy compliance. Private = professional/HNWI investors, lighter regime." },
        ],
    },
    {
        question: "What’s the capital requirement for asset managers?",
        content: [
            { type: "answer", text: "USD 150k for advisors, USD 250k for broker-dealers." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–9 months on average." },
        ],
    },
    {
        question: "Can Panama funds be marketed worldwide?",
        content: [
            { type: "answer", text: "Yes — though global recognition is stronger in LatAm, while EU funds prefer Luxembourg/Ireland." },
        ],
    },
    {
        question: "Is Panama tax-efficient for funds?",
        content: [
            { type: "answer", text: "Yes — foreign-sourced income (outside Panama) is tax-exempt." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We set up a private equity fund in Panama with Offshore Advisory. The SMV process was efficient, and investor trust was strong.",
        author: "Javier P.",
        role: "Fund Manager"
    },
    {
        quote: "Panama was ideal for our family office setup. Offshore Advisory guided us through the advisor license and custodian onboarding.",
        author: "Maria L.",
        role: "Asset Management Director"
    }
];
